(() => {
  const TERMS_URL='/policies/terms-of-service';
  const PRIVACY_URL='/policies/privacy-policy';
  const JACKET_HANDLES=new Set(['leather-jacket-1','the-jacket-red']);

  function isJacketPage(){
    const product=document.querySelector('[data-product-handle]');
    return product&&JACKET_HANDLES.has(product.dataset.productHandle);
  }

  function makeBox(){
    const b=document.createElement('div');
    b.className='oom-terms';
    b.dataset.oomTerms='';
    b.innerHTML=`<label class="oom-terms__label"><input type="checkbox" class="oom-terms__checkbox" data-oom-terms-checkbox><span>Elfogadom az <a href="${TERMS_URL}" target="_blank" rel="noopener">Általános Szerződési Feltételeket (ÁSZF)</a> és az <a href="${PRIVACY_URL}" target="_blank" rel="noopener">Adatkezelési tájékoztatót</a>.</span></label><div class="oom-terms__error" data-oom-terms-error role="alert" aria-live="polite" hidden>Az ÁSZF és az Adatkezelési tájékoztató elfogadása kötelező a továbblépéshez.</div>`;
    return b;
  }

  function valid(b){
    const c=b&&b.querySelector('[data-oom-terms-checkbox]');
    const e=b&&b.querySelector('[data-oom-terms-error]');
    const ok=!!(c&&c.checked);
    if(e)e.hidden=ok;
    if(b)b.classList.toggle('is-error',!ok);
    return ok;
  }

  function wireBox(b){
    const c=b.querySelector('[data-oom-terms-checkbox]');
    if(!c)return;
    c.addEventListener('click',e=>e.stopPropagation());
    c.addEventListener('change',()=>{if(c.checked)valid(b)});
    const l=b.querySelector('.oom-terms__label');
    if(l)l.addEventListener('click',e=>{
      if(e.target.closest('a')||e.target===c)return;
      e.preventDefault();e.stopPropagation();c.checked=!c.checked;
      c.dispatchEvent(new Event('change',{bubbles:true}));
    });
  }

  function product(form){
    if(form.dataset.oomTermsReady)return;
    const submit=form.querySelector('button[name="add"],button[type="submit"],input[type="submit"]');
    if(!submit)return;
    form.dataset.oomTermsReady='1';
    const b=makeBox();
    const target=submit.closest('.product-form__controls-group--submit')||submit.parentElement;
    target.parentNode.insertBefore(b,target);
    wireBox(b);
    form.addEventListener('submit',e=>{
      if(!valid(b)){e.preventDefault();e.stopImmediatePropagation();b.querySelector('input').focus();}
    },true);
    const dyn=form.querySelector('.shopify-payment-button');
    if(dyn)dyn.addEventListener('click',e=>{
      if(!valid(b)){e.preventDefault();e.stopImmediatePropagation();b.querySelector('input').focus();}
    },true);
  }

  function removeCartBoxes(){
    document.querySelectorAll('.cart-drawer .oom-terms,[data-cart-drawer] .oom-terms,.quick-cart .oom-terms,[data-quick-cart] .oom-terms,form[action="/cart"] .oom-terms').forEach(el=>el.remove());
  }

  function init(){
    removeCartBoxes();
    if(!isJacketPage())return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(product);
  }

  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  new MutationObserver(init).observe(document.documentElement,{childList:true,subtree:true});
})();